import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';

// Mirrors the backend's snapshot.JurisdictionLocation, so dates worked out here
// line up with the ones the publish snapshot uses. Jurisdictions without a
// mapping fall back to UTC, as they do there.
const TIME_ZONES: Readonly<Partial<Record<number, string>>> = {
  [Jurisdiction.NZ_MOE]: 'Pacific/Auckland',
  [Jurisdiction.AU_NSW]: 'Australia/Sydney',
};

export function jurisdictionTimeZone(
  jurisdiction: number | null | undefined,
): string {
  return (jurisdiction != null && TIME_ZONES[jurisdiction]) || 'UTC';
}

// schoolLocalDate returns the calendar date (YYYY-MM-DD) at `now` in the
// school's timezone, rather than the browser's.
export function schoolLocalDate(
  jurisdiction: number | null | undefined,
  now: Date = new Date(),
): string {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: jurisdictionTimeZone(jurisdiction),
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(now);
  const get = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value ?? '';
  return `${get('year')}-${get('month')}-${get('day')}`;
}
